import api from "../services/api";
import { ICourt } from "../models/ICourt";
import {
  ICourtReservation,
  ICreateReservationRequest,
  IUpdateReservationRequest,
  IRecurringTrainingRequest,
  IReservationReport,
  IReservationCategory,
  ICreateReservationCategory,
  IUpdateReservationCategory,
} from "../models/ICourtReservation";
import qs from "qs";

// Court Management
export const getAllCourts = (): Promise<{ data: ICourt[] }> => api.get("court");

export const getActiveCourts = (): Promise<{ data: ICourt[] }> => api.get("court/active");

export const getCourtById = (id: string): Promise<{ data: ICourt }> => api.get(`court/${id}`);

export const createCourt = (data: { name: string; description?: string; isActive?: boolean }): Promise<{ data: ICourt }> =>
  api.post("court", data);

export const updateCourt = (id: string, data: { name?: string; description?: string; isActive?: boolean }): Promise<{ data: ICourt }> =>
  api.put(`court/${id}`, data);

export const deleteCourt = (id: string): Promise<{ data: boolean }> => api.delete(`court/${id}`);

// Reservation Category Management
export const getAllCategories = (): Promise<{ data: IReservationCategory[] }> => api.get("court/categories");

export const getActiveCategories = (): Promise<{ data: IReservationCategory[] }> => api.get("court/categories/active");

export const getCategoryById = (id: string): Promise<{ data: IReservationCategory }> => api.get(`court/categories/${id}`);

export const createCategory = (data: ICreateReservationCategory): Promise<{ data: IReservationCategory }> =>
  api.post("court/categories", data);

export const updateCategory = (id: string, data: IUpdateReservationCategory): Promise<{ data: IReservationCategory }> =>
  api.put(`court/categories/${id}`, data);

export const deleteCategory = (id: string): Promise<{ data: boolean }> => api.delete(`court/categories/${id}`);

// Reservation Management
export const getAllReservations = (params?: {
  courtId?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  status?: number;
  reservationCategoryId?: string;
}): Promise<{ data: ICourtReservation[] }> => {
  const queryParams: Record<string, any> = {};
  if (params?.courtId) queryParams.courtId = params.courtId;
  if (params?.userId) queryParams.userId = params.userId;
  if (params?.startDate) queryParams.startDate = params.startDate;
  if (params?.endDate) queryParams.endDate = params.endDate;
  if (params?.status) queryParams.status = params.status;
  if (params?.reservationCategoryId) queryParams.reservationCategoryId = params.reservationCategoryId;

  return api.get("court/reservations", {
    params: queryParams,
    paramsSerializer: (params) => qs.stringify(params),
  });
};

export const getReservationById = (id: string): Promise<{ data: ICourtReservation }> => api.get(`court/reservations/${id}`);

export const getReservationsByCourt = (courtId: string): Promise<{ data: ICourtReservation[] }> =>
  api.get(`court/reservations/court/${courtId}`);

export const getMyReservations = (): Promise<{ data: ICourtReservation[] }> => api.get("court/reservations/my");

export const createReservation = (data: ICreateReservationRequest): Promise<{ data: ICourtReservation }> =>
  api.post("court/reservations", data);

export const createBulkReservations = (data: { reservations: ICreateReservationRequest[] }): Promise<{ data: ICourtReservation[] }> =>
  api.post("court/reservations/bulk", data);

export const createRecurringTrainingReservations = (data: IRecurringTrainingRequest): Promise<{ data: ICourtReservation[] }> =>
  api.post("court/reservations/recurring-training", data);

export const updateReservation = (id: string, data: IUpdateReservationRequest): Promise<{ data: ICourtReservation }> =>
  api.put(`court/reservations/${id}`, data);

export const deleteReservation = (id: string): Promise<{ data: boolean }> => api.delete(`court/reservations/${id}`);

export const getReservationReport = (params: {
  month?: number;
  year?: number;
  startDate?: string;
  endDate?: string;
}): Promise<{ data: IReservationReport }> => {
  const queryParams: Record<string, any> = {};
  if (params.month) queryParams.month = params.month;
  if (params.year) queryParams.year = params.year;
  if (params.startDate) queryParams.startDate = params.startDate;
  if (params.endDate) queryParams.endDate = params.endDate;

  return api.get("court/reservations/report", {
    params: queryParams,
    paramsSerializer: (params) => qs.stringify(params),
  });
};

export const checkAvailability = (params: {
  courtId: string;
  startTime: string;
  endTime: string;
  excludeReservationId?: string;
}): Promise<{ data: boolean }> => {
  const queryParams: Record<string, any> = {
    courtId: params.courtId,
    startTime: params.startTime,
    endTime: params.endTime,
  };
  if (params.excludeReservationId) queryParams.excludeReservationId = params.excludeReservationId;

  return api.get("court/reservations/availability", {
    params: queryParams,
    paramsSerializer: (params) => qs.stringify(params),
  });
};
